import React from 'react';
import { useSelector } from 'react-redux';
import { getPageImage } from 'app/stores/selectors';
import { Blurs } from 'app/views/components/editor/slide/Blurs';
import { DebugPoints } from 'app/views/components/editor/slide/Debug';
import { Marks } from 'app/views/components/editor/slide/Markers';
import { Pins } from 'app/views/components/editor/slide/Pins';
import { Spots } from 'app/views/components/editor/slide/Spots';
import { Texts } from 'app/views/components/editor/slide/Texts';
import { Image } from 'app/views/components/svg/Image';
import { SVG } from 'app/views/components/svg/SVG';
export const SlideImageView = (props) => {
    const { id: slideId, viewBox, keepAspectRatio = false } = props;
    const slideImage = useSelector((state) => getPageImage(state, slideId));
    if (!slideImage) {
        return null;
    }
    return (React.createElement(SVG, { id: "project-preview", width: "100%", height: "100%", preserveAspectRatio: keepAspectRatio ? undefined : 'none', viewBox: viewBox
            ? `${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`
            : undefined },
        React.createElement("defs", null,
            React.createElement("filter", { id: "text-field-shadow" },
                React.createElement("feDropShadow", { dx: "0", dy: "2", stdDeviation: "1", floodColor: "#000000", floodOpacity: "0.2" }))),
        React.createElement("g", { id: "image" },
            React.createElement(Image, { src: slideImage.url, width: slideImage.size.width, height: slideImage.size.height }),
            slideImage.blurredImage && React.createElement(Blurs, null),
            React.createElement(Spots, null)),
        React.createElement(Marks, { dataKey: "marks" }),
        React.createElement(Pins, null),
        React.createElement(Texts, null),
        React.createElement(DebugPoints, null)));
};
